import { useAppConfig } from "../AppConfigProvider";
import { Linking, Platform } from "react-native";
import Sentry from "../utils/sentry";
import { getValidAccessToken } from "../utils/authRefresh";

const useFileFetch = () => {
  const appConfig = useAppConfig();
  const currentDomain = appConfig?.currentDomain || "";

  const fetchAndOpenFile = async (url) => {
    const fullUrl = url.startsWith("/") ? `https://${currentDomain}${url}` : url;

    if (Platform.OS === "web") {
      try {
        const token = await getValidAccessToken();
        if (!token) {
          throw new Error("Missing access token for file fetch");
        }
        const form = document.createElement("form");
        form.method = "POST";
        form.action = fullUrl;
        form.target = "_blank";

        const tokenInput = document.createElement("input");
        tokenInput.type = "hidden";
        tokenInput.name = "token";
        tokenInput.value = token;
        form.appendChild(tokenInput);

        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
      } catch (err) {
        console.error("Failed to open URL:", err);
        Sentry.captureException(err);
      }
    } else {
      try {
        const token = await getValidAccessToken();
        if (!token) {
          throw new Error("Missing access token for file fetch");
        }
        const response = await fetch(fullUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: `token=${encodeURIComponent(token)}`,
        });
        const finalUrl = response.url;
        Linking.openURL(finalUrl);
      } catch (err) {
        console.error("Failed to open URL:", err);
        Sentry.captureException(err);
      }
    }
  };

  return { fetchAndOpenFile };
};

export default useFileFetch;
